import { Suspense } from "react";
import {Navigate, useOutlet} from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export const UnprotectedLayout = () => {
    const { user } = useAuth();
    const outlet = useOutlet();

    if (user) {
        return <Navigate to="/dashboard" />;
    }

    return (
        <Suspense fallback={null}>
            {outlet}
        </Suspense>
    )
};
